<template functional>
  <div class="custom-control custom-switch">
    <input
      class="custom-control-input"
      type="checkbox"
      :id="props.id"
      :checked="props.value"
      @change="listeners.input($event.target.checked)"
    />
    <label class="custom-control-label" :for="props.id">
      {{ props.text }}
    </label>
  </div>
</template>

<script>
  export default {
    name: 'SwitchComponent',
    functional: true,
    props: {
      id: {
        type: String,
        required: true
      },
      text: {
        type: String,
        default: () => ''
      },
      value: {
        type: Boolean,
        required: true
      }
    }
  }
</script>